import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { useClients } from '~/hooks/reactQuery/queries/useClients';
import { getBillableClientIds, getBillableGroupedOptions, getCrmClientOptions, getDefaultRelationshipId } from './GlobalBillingHub.utils';
import { useClientAgreementSummaries } from './hooks/useClientAgreementSummaries';
export function GlobalBillingHubData(param) {
    let { agreements, clientId, relationshipId, changeUrlState, children } = param;
    const { clients } = useClients({
        refreshOnHookMount: true
    });
    const billableClientIds = useMemo(()=>getBillableClientIds(agreements), [
        agreements
    ]);
    const { summaries: clientSummaries } = useClientAgreementSummaries(clientId);
    const groupedOptions = useMemo(()=>getBillableGroupedOptions(clientSummaries), [
        clientSummaries
    ]);
    const agreementOptions = useMemo(()=>[
            ...groupedOptions.agreements,
            ...groupedOptions.adHocRelationships
        ], [
        groupedOptions
    ]);
    const clientOptions = useMemo(()=>getCrmClientOptions(clients, billableClientIds), [
        clients,
        billableClientIds
    ]);
    const selectedClient = useMemo(()=>{
        var _clientOptions_find;
        return clientId ? (_clientOptions_find = clientOptions.find((opt)=>opt.id === clientId)) !== null && _clientOptions_find !== void 0 ? _clientOptions_find : null : null;
    }, [
        clientId,
        clientOptions
    ]);
    useEffect(()=>{
        if (clientId && clientOptions.length > 0 && clientOptions.every((o)=>o.id !== clientId)) changeUrlState({
            clientId: ''
        });
    }, [
        clientId,
        clientOptions,
        changeUrlState
    ]);
    useEffect(()=>{
        if (!agreementOptions.length) return;
        if (relationshipId && agreementOptions.every((o)=>o.id !== relationshipId)) changeUrlState({
            relationshipId: ''
        });
    }, [
        relationshipId,
        agreementOptions,
        changeUrlState
    ]);
    useEffect(()=>{
        if (clientId && !relationshipId && agreementOptions.length) changeUrlState({
            relationshipId: getDefaultRelationshipId(agreementOptions)
        });
    }, [
        clientId,
        relationshipId,
        agreementOptions,
        changeUrlState
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children({
            clientOptions,
            groupedOptions,
            selectedClient
        })
    });
}
